import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE_BLENDED     = `${config.API_URL}Beacon4Blended`;
const BASE_PERFORMANCE = `${config.API_URL}Beacon4Performance`;

export const GetBeacon4SidePolygons = () =>
	AxiosRequest({ method: 'GET', url: `${BASE_BLENDED}/GetSidePolygons` });

export const GetBeacon4KpiConfig = (tech) =>
	AxiosRequest({ method: 'GET', url: `${BASE_BLENDED}/GetKpiConfig`, params: { tech } });

export const GetBeacon4KpiSeries = (params) =>
	AxiosRequest({ method: 'GET', url: `${BASE_BLENDED}/GetKpiSeries`, params });

export const GetBeacon4BlendedSummary = (params) =>
	AxiosRequest({ method: 'GET', url: `${BASE_BLENDED}/GetBlendedSummary`, params });

export const GetBeacon4BlendedSeries = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_BLENDED}/GetBlendedSeries`, data });

export const GetBeacon4RagThresholds = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_BLENDED}/GetRagThresholds`, data });

// Performance
export const GetBeacon4PerformanceDashboard = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_PERFORMANCE}/GetDashboardSeries`, data });

// Aggregation Mode table (rows = group dimension values, columns = dates)
export const GetBeacon4PerformanceTable = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE_PERFORMANCE}/GetAggregationTable`, data });

// Returns { techs: [...], kpisByTech: { '2G': [{key, label}], ... } }
export const GetBeacon4PerformanceAvailableKpis = () =>
	AxiosRequest({ method: 'GET', url: `${BASE_PERFORMANCE}/GetAvailableKpis` });
